/**
 * Clamps a number between the configured `min` and `max` values.
 * @param {number} min
 * @param {number} max
 * @returns {(n:number) => number}
 */
export default (min, max) => (n) => Math.min(Math.max(n, min), max);
